// Recovered compiled webpack factory 66941. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { H: () => h });
  var n = r(61571),
    a = r(24617),
    o = r(43275),
    i = r(16649),
    s = r(76871),
    l = r(28385),
    u = r(17588),
    c = r(78714),
    f = r(43316),
    d = r(35868),
    p = r(87624);
  class h {
    constructor() {
      ((this._notifyingListeners = !1),
        (this._scopeListeners = []),
        (this._eventProcessors = []),
        (this._breadcrumbs = []),
        (this._attachments = []),
        (this._user = {}),
        (this._tags = {}),
        (this._attributes = {}),
        (this._extra = {}),
        (this._contexts = {}),
        (this._sdkProcessingMetadata = {}),
        (this._propagationContext = { traceId: (0, u.e)(), sampleRand: (0, c.hY)() }));
    }
    clone() {
      let e = new h();
      return (
        (e._breadcrumbs = [...this._breadcrumbs]),
        (e._tags = { ...this._tags }),
        (e._attributes = { ...this._attributes }),
        (e._extra = { ...this._extra }),
        (e._contexts = { ...this._contexts }),
        this._contexts.flags && (e._contexts.flags = { values: [...this._contexts.flags.values] }),
        (e._user = this._user),
        (e._level = this._level),
        (e._session = this._session),
        (e._transactionName = this._transactionName),
        (e._fingerprint = this._fingerprint),
        (e._eventProcessors = [...this._eventProcessors]),
        (e._attachments = [...this._attachments]),
        (e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }),
        (e._propagationContext = { ...this._propagationContext }),
        (e._client = this._client),
        (e._lastEventId = this._lastEventId),
        (e._conversationId = this._conversationId),
        (0, f.r)(e, (0, f.f)(this)),
        e
      );
    }
    setClient(e) {
      this._client = e;
    }
    setLastEventId(e) {
      this._lastEventId = e;
    }
    getClient() {
      return this._client;
    }
    lastEventId() {
      return this._lastEventId;
    }
    addScopeListener(e) {
      this._scopeListeners.push(e);
    }
    addEventProcessor(e) {
      return (this._eventProcessors.push(e), this);
    }
    setUser(e) {
      return (
        (this._user = e || { email: void 0, id: void 0, ip_address: void 0, username: void 0 }),
        this._session && (0, a.qO)(this._session, { user: e }),
        this._notifyScopeListeners(),
        this
      );
    }
    getUser() {
      return this._user;
    }
    setConversationId(e) {
      return ((this._conversationId = e || void 0), this._notifyScopeListeners(), this);
    }
    setTags(e) {
      return ((this._tags = { ...this._tags, ...e }), this._notifyScopeListeners(), this);
    }
    setTag(e, t) {
      return this.setTags({ [e]: t });
    }
    setAttributes(e) {
      return (
        (this._attributes = { ...this._attributes, ...e }),
        this._notifyScopeListeners(),
        this
      );
    }
    setAttribute(e, t) {
      return this.setAttributes({ [e]: t });
    }
    removeAttribute(e) {
      return (
        e in this._attributes && (delete this._attributes[e], this._notifyScopeListeners()),
        this
      );
    }
    setExtras(e) {
      return ((this._extra = { ...this._extra, ...e }), this._notifyScopeListeners(), this);
    }
    setExtra(e, t) {
      return ((this._extra = { ...this._extra, [e]: t }), this._notifyScopeListeners(), this);
    }
    setFingerprint(e) {
      return ((this._fingerprint = e), this._notifyScopeListeners(), this);
    }
    setLevel(e) {
      return ((this._level = e), this._notifyScopeListeners(), this);
    }
    setTransactionName(e) {
      return ((this._transactionName = e), this._notifyScopeListeners(), this);
    }
    setContext(e, t) {
      return (
        null === t ? delete this._contexts[e] : (this._contexts[e] = t),
        this._notifyScopeListeners(),
        this
      );
    }
    setSession(e) {
      return (e ? (this._session = e) : delete this._session, this._notifyScopeListeners(), this);
    }
    getSession() {
      return this._session;
    }
    update(e) {
      if (!e) return this;
      let t = "function" == typeof e ? e(this) : e,
        {
          tags: r,
          attributes: n,
          extra: a,
          user: o,
          contexts: s,
          level: l,
          fingerprint: u = [],
          propagationContext: c,
          conversationId: f,
        } = (t instanceof h ? t.getScopeData() : (0, i.Qd)(t) ? e : void 0) || {};
      return (
        (this._tags = { ...this._tags, ...r }),
        (this._attributes = { ...this._attributes, ...n }),
        (this._extra = { ...this._extra, ...a }),
        (this._contexts = { ...this._contexts, ...s }),
        o && Object.keys(o).length && (this._user = o),
        l && (this._level = l),
        u.length && (this._fingerprint = u),
        c && (this._propagationContext = c),
        f && (this._conversationId = f),
        this
      );
    }
    clear() {
      return (
        (this._breadcrumbs = []),
        (this._tags = {}),
        (this._attributes = {}),
        (this._extra = {}),
        (this._user = {}),
        (this._contexts = {}),
        (this._level = void 0),
        (this._transactionName = void 0),
        (this._fingerprint = void 0),
        (this._session = void 0),
        (this._conversationId = void 0),
        (0, f.r)(this, void 0),
        (this._attachments = []),
        this.setPropagationContext({ traceId: (0, u.e)(), sampleRand: (0, c.hY)() }),
        this._notifyScopeListeners(),
        this
      );
    }
    addBreadcrumb(e, t) {
      let r = "number" == typeof t ? t : 100;
      if (r <= 0) return this;
      let n = {
        timestamp: (0, p.lu)(),
        ...e,
        message: e.message ? (0, d.xv)(e.message, 2048) : e.message,
      };
      return (
        this._breadcrumbs.push(n),
        this._breadcrumbs.length > r &&
          ((this._breadcrumbs = this._breadcrumbs.slice(-r)),
          this._client?.recordDroppedEvent("buffer_overflow", "log_item")),
        this._notifyScopeListeners(),
        this
      );
    }
    getLastBreadcrumb() {
      return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    clearBreadcrumbs() {
      return ((this._breadcrumbs = []), this._notifyScopeListeners(), this);
    }
    addAttachment(e) {
      return (this._attachments.push(e), this);
    }
    clearAttachments() {
      return ((this._attachments = []), this);
    }
    getScopeData() {
      return {
        breadcrumbs: this._breadcrumbs,
        attachments: this._attachments,
        contexts: this._contexts,
        tags: this._tags,
        attributes: this._attributes,
        extra: this._extra,
        user: this._user,
        level: this._level,
        fingerprint: this._fingerprint || [],
        eventProcessors: this._eventProcessors,
        propagationContext: this._propagationContext,
        sdkProcessingMetadata: this._sdkProcessingMetadata,
        transactionName: this._transactionName,
        span: (0, f.f)(this),
        conversationId: this._conversationId,
      };
    }
    setSDKProcessingMetadata(e) {
      return ((this._sdkProcessingMetadata = (0, s.h)(this._sdkProcessingMetadata, e, 2)), this);
    }
    setPropagationContext(e) {
      return ((this._propagationContext = e), this);
    }
    getPropagationContext() {
      return this._propagationContext;
    }
    captureException(e, t) {
      let r = t?.event_id || (0, l.eJ)();
      if (!this._client)
        return (n.T && o.Yz.warn("No client configured on scope - will not capture exception!"), r);
      let a = Error("Sentry syntheticException");
      return (
        this._client.captureException(
          e,
          { originalException: e, syntheticException: a, ...t, event_id: r },
          this,
        ),
        r
      );
    }
    captureMessage(e, t, r) {
      let a = r?.event_id || (0, l.eJ)();
      if (!this._client)
        return (n.T && o.Yz.warn("No client configured on scope - will not capture message!"), a);
      let i = r?.syntheticException ?? Error(e);
      return (
        this._client.captureMessage(
          e,
          t,
          { originalException: e, syntheticException: i, ...r, event_id: a },
          this,
        ),
        a
      );
    }
    captureEvent(e, t) {
      let r = e.event_id || t?.event_id || (0, l.eJ)();
      return (
        this._client
          ? this._client.captureEvent(e, { ...t, event_id: r }, this)
          : n.T && o.Yz.warn("No client configured on scope - will not capture event!"),
        r
      );
    }
    _notifyScopeListeners() {
      this._notifyingListeners ||
        ((this._notifyingListeners = !0),
        this._scopeListeners.forEach((e) => {
          e(this);
        }),
        (this._notifyingListeners = !1));
    }
  }
}
